import { render, staticRenderFns } from "./xeFemsOverview.vue?vue&type=template&id=2ef0d45c&scoped=true"
import script from "./xeFemsOverview.vue?vue&type=script&lang=js"
export * from "./xeFemsOverview.vue?vue&type=script&lang=js"
import style0 from "./xeFemsOverview.vue?vue&type=style&index=0&id=2ef0d45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef0d45c",
  null
  
)

export default component.exports